import type { CustomerSourceType } from '@/types';
import {
  fetchAddCustomerSourceDocument,
  fetchAddCustomerSourceMiniProgramDocument,
  fetchReportedDistributorRecordDocument,
  fetchUserClickBuriedPointDocument,
  fetchUserClickProductBuriedPointDocument,
  fetchUserDeviceDocument,
} from '../graphql/docs';
import { fetcher } from '../graphql/fetcher/index';

/**
 * 程序启动（热启动）上报
 */
export const fetchUserClickBuriedPoint = async () => {
  await fetcher.mutation(fetchUserClickBuriedPointDocument, {});
};

/**
 * 商品点击上报
 * @param productId - 商品id
 */
export const fetchUserClickProductBuriedPoint = async (productId: string) => {
  await fetcher.mutation(fetchUserClickProductBuriedPointDocument, {
    productId,
  });
};

/**
 * 用户设备信息上报
 * @param productId - 商品id
 */
export const fetchUserDevice = async (openIdKey: string, deviceInfo: AnyObject) => {
  if (!openIdKey) return;
  await fetcher.mutation(fetchUserDeviceDocument, {
    openIdKey,
    deviceInfo,
  });
};

/**
 * 分销信息上报
 * @param md5Str
 * @param sourceCode
 * @param distributionId
 */
export const fetchReportedDistributorRecord = async (
  md5Str: string,
  sourceCode: string,
  distributionId = ''
) => {
  const res = await fetcher.mutation(fetchReportedDistributorRecordDocument, {
    md5Str,
    sourceCode,
    distributionId,
  });
  console.log(`分销信息上报 => `, {
    requestParams: {
      md5Str,
      sourceCode,
      distributionId,
    },
    responseData: res.data,
  });
};

/**
 * 来源信息上报
 * @param sourceType
 * @param sourceValue
 */
export const fetchAddCustomerSource = async (
  sourceType: CustomerSourceType,
  sourceValue: string
) => {
  await fetcher.mutation(fetchAddCustomerSourceDocument, {
    customerSourceInput: {
      sourceType,
      sourceValue,
    },
  });
};

/**
 * 小程序来源信息上报
 * @param customerReferralInput
 */
export const fetchAddCustomerSourceMiniProgram = async (customerReferralInput: {
  sourceType: string;
  sourceValue: string;
  additionalInfo?: string;
}) => {
  await fetcher.mutation(fetchAddCustomerSourceMiniProgramDocument, {
    customerReferralInput,
  });
};
